var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('dynamic-zone-renderer',{attrs:{"components":_vm.content.components,"add-paddings":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }